import classnames from "classnames";
import { PropsWithChildren } from "react";

import Button from "@/components/button/button";
import { IconNames } from "@/components/icon/icon";
import { ItemCardContent } from "@/features/widget-forms/forms/weather-model-map/components/item-card-content/item-card-content";

import styles from "./check-card.module.css";

export interface StatusLabel {
  text: string;
  icon?: IconNames;
}

interface CheckCardProps {
  checked?: boolean;
  title: string;
  /** Custom status label to show. If not provided and checked is true, shows default "Already added" */
  statusLabel?: StatusLabel | string;
}

const CheckCard = ({
  checked,
  title,
  children,
  statusLabel,
  disabled,
  ...props
}: PropsWithChildren<CheckCardProps & React.ButtonHTMLAttributes<HTMLButtonElement>>) => {
  const getStatus = (): StatusLabel | null => {
    if (!statusLabel) return null;
    return typeof statusLabel === "string" ? { text: statusLabel } : statusLabel;
  };

  const status = getStatus();

  return (
    <Button
      type="button"
      {...props}
      className={classnames(
        styles.checkCard,
        { [styles.checked]: checked },
        { [styles.disabled]: disabled },
        props.className,
      )}
      variant="ghost"
      disabled={checked || disabled || undefined}
    >
      <ItemCardContent title={title} subtitle={children} status={status ?? undefined} />
    </Button>
  );
};

export default CheckCard;
